import { render, staticRenderFns } from "./CellRendererRemarksInput.vue?vue&type=template&id=68a90418&scoped=true"
import script from "./CellRendererRemarksInput.vue?vue&type=script&lang=js"
export * from "./CellRendererRemarksInput.vue?vue&type=script&lang=js"
import style0 from "./CellRendererRemarksInput.vue?vue&type=style&index=0&id=68a90418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a90418",
  null
  
)

export default component.exports